import { inject, Injectable } from '@angular/core';
import { Store } from '@ngxs/store';
import { LoadableHelper } from '@aiwyn/shared';
// OLD MODULE DEPENDENCY: imports from legacy ClientRequestsState.
// Remove when CXP owns its own detail view.
import { ClientRequestsState, InitializeClientRequests } from '../../client-requests/state';

/**
 * Bridges CXP task data into the legacy ClientRequestsState so the detail panel
 * loads without waiting for a full InitializeClientRequests cycle.
 *
 * Called after CXP tasks load to speculatively dispatch InitializeClientRequests
 * so groups + secondary data are fetched in the background while the user browses
 * the task list. We intentionally do NOT pre-seed requests: GetAllClientRequests
 * skips its API call when it finds all items already LOADED, which would leave
 * stale request data indefinitely. Letting it fetch fresh ensures up-to-date data.
 *
 * OLD MODULE DEPENDENCY: remove this service when CXP owns its own detail view
 * and no longer relies on ClientRequestsModule / ClientRequestsState.
 */
@Injectable({ providedIn: 'root' })
export class ClientRequestsBridgeService {
  private readonly store = inject(Store);

  prewarmLegacyState(): void {
    // Speculatively kick off the full legacy state initialization so groups + secondary
    // data are ready by the time the user clicks a task card.
    const legacyStatus = this.store.selectSnapshot(ClientRequestsState.getSlices.status);
    if (LoadableHelper.shouldRequest(legacyStatus)) {
      this.store.dispatch(new InitializeClientRequests());
    }
  }
}
